/**
 * Demographics print route helper (opens in a new tab).
 */
export const demographicsPrintUrl = (patientId) =>
  `/patients/${patientId}/demographics/print`;
